module.exports = __webpack_public_path__ + "static/media/robin-moran-home-warranty-reviews_160px.5f91784b.jpg";